<template>
  <div class="pl">
    <div class="van-nav-bar van-hairline--bottom">
    	<div class="van-nav-bar__content">
    		<!---->
    		<div class="van-nav-bar__title van-ellipsis">
    			{{$t('common.pingluntitle')}}
    		</div>
    		<!----></div>
    </div>
    <van-pull-refresh v-model="isLoading" class="fixedStyle"  @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('common.nomore')"
          @load="onLoad">
		  <van-cell-group>
		    <van-cell v-for="(item,i) in tableList" :key="i" :title="item.title" :value="item.auther" :label="item.content" @click="quickList(item.id)" >
				<template #title>
					<div style="display: flex;">
						<svg t="1721097804862" class="icon" viewBox="0 0 1024 1024" version="1.1"
						xmlns="http://www.w3.org/2000/svg" p-id="5354" width="30" height="30">
							<path d="M102.4 102.4m307.2 0l204.8 0q307.2 0 307.2 307.2l0 204.8q0 307.2-307.2 307.2l-204.8 0q-307.2 0-307.2-307.2l0-204.8q0-307.2 307.2-307.2Z"
							fill="#FC7E7E" fill-opacity=".2" p-id="5355">
							</path>
							<path d="M665.6 481.28a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H336.67072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 235.52 583.68v-20.48a81.92 81.92 0 0 1 81.92-81.92z m30.72-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L737.28 501.76l-38.42048-61.48096A83.43552 83.43552 0 0 1 696.32 440.32H450.56a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
							fill="#FC7E7E" fill-opacity=".4" p-id="5356">
							</path>
							<path d="M634.88 532.48a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H305.95072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 204.8 634.88v-20.48a81.92 81.92 0 0 1 81.92-81.92z m102.4-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L778.24 552.96l-38.42048-61.48096A83.43552 83.43552 0 0 1 737.28 491.52H491.52a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
							fill="#FC7E7E" p-id="5357">
							</path>
							<path d="M341.68832 607.04768c5.85728 0 10.38336 1.86368 13.84448 5.59104 3.9936 3.72736 5.85728 8.51968 5.85728 14.37696 0 5.3248-1.86368 10.11712-5.85728 14.11072-3.46112 3.46112-7.9872 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.9936-5.85728-8.78592-5.85728-14.11072 0-5.85728 2.12992-10.6496 5.85728-14.37696 3.9936-3.72736 8.78592-5.59104 14.11072-5.59104z m258.2528 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.92416 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.65792 0c5.3248 0 10.11712 1.59744 13.84448 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824 0 5.3248-1.86368 9.85088-5.59104 13.57824a19.08736 19.08736 0 0 1-13.84448 5.59104c-5.3248 0-10.11712-1.86368-13.84448-5.3248a18.8928 18.8928 0 0 1-5.85728-13.84448c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 14.11072-5.3248zM510.95552 378.88c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104A17.75616 17.75616 0 0 1 491.52 397.78304c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.92416 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104a17.75616 17.75616 0 0 1-5.85728-13.57824c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.65792 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-2.12992 10.11712-5.85728 13.84448c-3.72736 3.46112-8.51968 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-13.84448-5.59104a18.4832 18.4832 0 0 1-5.59104-13.57824c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 13.84448-5.3248z"
							fill="#FC3C3C" p-id="5358">
							</path>
						</svg>
						<h1 style="font-size: 0.9rem; padding-left: 1.1rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 14rem;">
							{{item.title}}
						</h1>
					</div>
				  </template>
			</van-cell>
		  </van-cell-group>
      </van-list>
      <van-empty :description="$t('common.nodata')" v-if="tableList.length === 0"/>
    </van-pull-refresh>
  </div>
  
</template>
<script>
import { Toast } from 'vant';
export default {
  data () {
    return {
      page:1,
      isLoading: false,
      count:0,
	  limit:10,
      loading: false,
      finished: false,
      refreshing: false,
      tableList:[],
    }
  },
  mounted () {
    this.getPinglunList()
    window.addEventListener("scroll", this.scrollTops, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTops);
  },
  methods: {
	quickList(id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Login'})
	  }else {
	    this.$router.push({path:'/PinglunDetail?id='+id})
	  }
	
	},
    longPress() {
      document.querySelector('.fixedStyle').scrollTop = 0
    },
    scrollTops(){
      this.scrollTop1 = document.querySelector('.fixedStyle').scrollTop
    },

    getPinglunList(){
        this.$http({
          method: 'get',
          data:{page: this.page,limit: this.limit},
          url: 'sys_pinglun'
        }).then(res=>{
			console.log(res);
          this.tableList  = this.tableList.concat(res.data.data);
          this.count = res.data.total;
          this.page++;      
        })
    },
    onRefresh(){
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t('common.refresh'));
      }, 500);
    },
    onLoad() {
      //初始化列表
      this.getPinglunList()
	  let timer = setTimeout(() => {
	    if (this.refreshing) {
	      this.tableList = [];
	      this.refreshing = false;
	    }
	    this.loading = false;
	    if (this.tableList.length === this.count) {
	      this.finished = true;
	    }
	    this.finished && clearTimeout(timer);//清除计时器
	  }, 500);
    },
  },
}
</script>
<style lang='less' scoped>
.van-nav-bar {
	position: relative;
    z-index: 999;
	height:3rem ;
	line-height: 3rem;
    background: url(/img/header.svg) no-repeat 50%/100%
}

.pl .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.8rem 0.6rem;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height:24px;
    background: #fff
}
	.pl {
	    padding-bottom: 3.33333rem
	}
	
	.pl .van-cell__value {
	    display: flex;
	    flex-direction: column;
	    justify-content: space-between;
	    align-items: flex-end
	}
	
	.pl .van-cell__value span {
	    background: #f33ddb;
	    color: #fff;
	    font-size: 0.8rem;
	    padding: 0.6rem 0.8rem;
	    border-radius: 0.2rem
	}
	
	.pl .van-cell__label {
	    width: 15rem;
		font-size: 0.8rem;
		line-height: 1.4rem;
	    white-space: nowrap;
	    overflow: hidden;
	    text-overflow: ellipsis
	}
</style>
